// @ts-expect-error
import t from '../helpers/calculator_translations';

interface WordsSelectorProps {
    words: number | null;
    wordsOptions: { [key: number]: string };
    action: (value: number) => void;
}
export const WordsSelector = ({ words, wordsOptions, action }: WordsSelectorProps): JSX.Element => {
    return (
        <select
            className={'form-control custom-select'}
            required
            aria-label={t('calculator.word_count')}
            onChange={(e) => {
                action(parseInt(e.target.value, 10));
            }}
            style={{ height: 'auto' }}
            value={words ?? ''}
        >
            {Object.entries(wordsOptions).map(([key, value]) => {
                return (
                    <option key={key} value={key}>
                        {value}
                    </option>
                );
            })}
        </select>
    );
};
